'use client';

import Cta from '@/components/pages/cta';
import { AnimatedFormServer } from './server';
import { useEffect, useRef, useState } from 'react';

export default function AnimatedFormClient() {
  const buttonRef = useRef<HTMLElement>(null);
  const [hideWrapperButton, setHideWrapperButton] = useState(false);
  const [hideAll, setHideAll] = useState(false);

  useEffect(() => {
    const el = buttonRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHideWrapperButton(true);
          observer.disconnect();
        }
      },
      { threshold: 0 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <AnimatedFormServer
      hideWrapperButton={hideWrapperButton}
      hideAll={hideAll}
      appendMessage={
        <Cta
          ref={buttonRef}
          text="Close"
          className="w-full mt-8"
          onClick={() => setHideAll(true)}
        />
      }
    />
  );
}
